export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB

// Allowed file types for upload
export const UPLOAD_FILE_TYPES_ACCEPT =
  ".docx,.xlsx,.pptx,.wopitest,.wopitestx,.pdf";
